import Router from "./Routes/Router";
import "./styles/PremiumCardPages.css";

function App() {
  return <Router />;
}

export default App;
